const authorBaseUrl = process.env.NEXT_PUBLIC_AUTHORBASEURL
const authorPreviewBaseUrl = process.env.NEXT_PUBLIC_PREVIEW_AUTHORBASEURL
const authorPreviewUserName = process.env.NEXT_PUBLIC_PREVIEW_USERNAME
const authorPreviewPassword = process.env.NEXT_PUBLIC_PREVIEW_PASSWORD
const previewContentPrefix = process.env.NEXT_PUBLIC_INTERNALLINKPATH
const publisherBaseUrl = process.env.NEXT_PUBLIC_PUBLISHERBASEURL
const baseUrl = process.env.NEXT_PUBLIC_BASEURL
const publicWebsiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL
export const isANYPersona =
  process.env.NEXT_PUBLIC_ENABLE_ANY_PERSONA === "true" ? true : false

const dataUrl = "/en.model.json"
const searchDataUrl = "/search.model.json"
const cartDataUrl = "/en/cart.model.json"
const headerUrl =
  "/content/experience-fragments/kohler/us/en/navigation/header/global-header-experience-fragment/master"
const footerUrl =
  "/content/experience-fragments/kohler/us/en/navigation/footer/Global-footer-experience-fragment/master"

const pageUrl = "/en/"
const cartPage = pageUrl + "cart"
const checkoutDataUrl = "/en/checkout.model.json"
const sharedCartUrl = "/en/cart/shared-cart.model.json"
const orderConfirmationDataUrl = "/en/orders/order-confirmation.model.json"
const orderDetailsPageDataUrl = "/en/orders/order-details.model.json"
const orderHistoryPageDataUrl = "/en/orders/order-history.model.json"
const orderStatusPageDataUrl = "/en/orders/order-status.model.json"
const returnSlipPageDataUrl = "/en/returns/return-slips.model.json"
const PRODUCT_DATA_URL = `/products/product-details.model.json`
export const PRODUCT_GLOBALCONFIG_DATA_URL = `.globalconfig.json`
const MyProductsPageDataUrl = "/my-account/my-products.model.json"
const loveYourLookDataUrl = "/en/love-your-look.model.json"
const pageNotFoundDataUrl = "/error-handler-pages/404.model.json"
const apiBaseUrl = process.env.NEXT_PUBLIC_APIBASEURL
const oktaTokenEndpoint = "/oauth/token"
const getCartEndPoint = "/cart/active?expand=calculation"
const createCartEndPoint = "/cart/create"
const getStockEndPoint = "/catalog/inventory"
const cartItemsEndPoint = "/cart/v2/items"
const sharedCartItemsEndPoint = "/cart/items"
export const shippingCostEndPoint = "/checkout/shipping-cost"
const discountEndPoint = "cart/v2/discount?expand=calculation"
const taxEndPoint = "/cart/v2/items?expand=calculation"
const shareCartEndPoint = "/cart/sharedcart"
const mergeCartEndPoint = "/cart/merge?expand=calculation"
const signupEndPoint = "/customer/signup"
const deleteCartEndPoint = "/cart/v2/deleteActiveCart"
export const shipmentFromCartEndPoint = "/checkout/v2/assign/shipmentfromcart"
const addAddressEndPoint = "/customer/address"
const addressSuggestionEndPoint = "/maps/address/validate"
const validateTokenEndPoint = "/oauth/token/validate"
const orderSubmitEndPoint = "/checkout/v2/order/submit"
const paymentEndPoint = "/checkout/payment"
const payPalPaymentEndPoint = "/payment/paypal/getToken"
const searchPlpEndPoint = "/search/plp"
const inPageSearchEndPoint = "/search/plp"
const searchProfilePlpEndPoint = "/search/profile"
export const checkSplitOrderEndPoint = "/checkout/order-split-check"
export const searchPdpEndPoint = "/search/pdp"
export const getPdpTooltipEndPoint = "/search/tooltip"
const accountSettingsPageDataUrl = "/my-account/account-settings.model.json"
const MY_PRODUCTS_ENDPOINT = "/shopping-list/MyProducts"
const FETCH_PRODUCT_REG_ENDPOINT = "/crm/fetchproductregistration"
const staticClasses = {
  CONTAINER: "container responsivegrid",
}
const MyServicePageDataUrl = "/my-account/my-services.model.json"
const MyFavoritesPageDataUrl = `/my-account/my-favorites.model.json`
const MyListsPageDataUrl = `/my-account/my-lists.model.json`
const REGISTER_OFFLINE_PRODUCTS_DATA_URL = `/my-account/product-registration/register-offline-product.model.json`
const REGISTER_ONLINE_PRODUCTS_DATA_URL = `/en/my-account/product-registration/register-online-product.model.json`
const FAQ_PAGE_DATA_URL = "/support/help-and-faq"
const browseAllStoresURL = "/en/locations/browse-all-stores.model.json"
const LITERATURE_DATA_URL = "/en/for-professionals/literature.model.json"
const TECHNICAL_SPECIFICATION_DATA_URL =
  "/en/for-professionals/technical-specifications.model.json"
const PRESS_LANDING_URL = "/en/press-room.model.json"
const FIND_STORE_URL = "en/locations.model.json"
const ARTICLE_CONTENT_END_POINT = "/jcr:content.json"
const ARTICLE_IMG_END_POINT = "/jcr:content/image.json"
const FAVORITES_LIST_END_POINT = "/shopping-list/FavoriteLists"
const USER_LIST_DELETE_END_POINT = "/shopping-list"
const USER_LIST_PRODUCT_DELETE_POINT = "/shopping-list/remove/items"
const FAVORITES_LIST_LIMIT = 499
export const MODEL_JSON_EXTENSION = ".model.json"
export const dynamicSearch = "dynamic search"
export const dimensionsDataEndPoint = "/search/plp"
export const findAllStores = "/maps/store"
export const HELP_AND_FAQ_SUPPORT = "/en/support/help-and-faq"
export const missingImage = "MissingImage"
export const skuBypimLookup = `/scout/service/api/customer/mavenoid`
const CONSTANTS = {
  DEFAULT_IDLE_TIMEOUT: 172800, // In Seconds
  DEFAULT_VERSION: "v1",
  ERROR_CODES: {
    BAD_REQUEST_ERROR: 400,
    INTERNAL_SERVER_ERROR: 500,
    AUTHENTICATION_ERROR: [401, 403],
  },
  USER_STATE: {
    LOGGED_USER: "logged",
    ANONYMOUS_USER: "anonymous",
  },
  PARENT_COMPONENTS_LIST: {
    ORDER_DETAILS: "OrderDetails",
  },
  PAYMENT: {
    SUCCESS_CODE: "870",
    NUM_YEARS: 16,
  },
  ORDER_STATUS_SHIPPED: "Shipped",
  DELETE_INACTIVE_MYFOLDER_AFTER: 30,
  ERROR_MESSAGE: {
    GENERAL: "Something went wrong. Please try again...",
    SESSION_TIMEOUT_MSG: "Your session is expired.. Please login again...",
    SESSION_TIMEOUT_SECURE_PAGE_MSG:
      "Redirecting to Home Page due to inactivity",
  },
  COLOR_FILE_URL: "https://kohler.scene7.com/is/image/PAWEB/", // TODO: Obtain value from config
  CT_API_URL: "https://api.us-central1.gcp.commercetools.com", // TODO: Obtain value from config
  CT_PROJECT_KEY: "kohler-na-qa-1", // TODO: Obtain value from config
  CT_SALES_CHANNEL: "KOUS", // TODO: Obtain value from config
  REGEX_TEXT: /^[a-z\d\-,'"\s]+$/,
  REGEX_ALPHANUMERIC_SAFE_CHARS: /^[a-z\d\-,'"\s]+$/i,
  REGEX_PASSWORD: new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{11,})"
  ),
  REGEX_EMAIL:
    /^((?!\.)(?!\-)(?!\_)[a-z0-9]*([\.\-\_]?[a-z0-9\-]*)?[^\-`_.#()+/=!@$%^&*:'"<>])(@(?!\.)(?!\-)(?!\_)[\w-]+)(\.\w+(\.\w+)?[^.\W])$/i,
  KEYCODE: { ENTER: 13, ESC: 27, SPACE: 32, UP: 38, DOWN: 40, TAB: 9 },
  KEY: { ENTER: "Enter", ESC: "Escape" },
  FF_PERSONA: "US_Kcom_FriendsNFamily:FF",
  KEMP_PERSONA: "US_Kcom_KohlerCoAssociate:KEMP",
  KF_FORCE_RENEW_TOKEN: "kf-okta-force-renew-token",
  KF_UPDATE_MEMBERSHIP: "kf-update-membership",
  CREATE_ACCOUNT_TYPE: {
    HOME_OWNER: "homeowner",
    PROFESSIONAL: "professional",
  },
  UNDEFINED: "undefined",
  COMPONENT: {
    PAIRS_WELL_WITH: "pairsWellWith",
  },
  SLICK: {
    DEFAULT_DELAY: 5000,
    COUNT_OFFSET: 22,
    ARROW_OFFSET: 52,
  },
  CURRENCY_SIGN: "$",
  STATUS: {
    OK: 200,
    PAGE_NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
  },
  REGEX_CONTAINS_LETTER: /[a-z]/i,
  BROWSER_NO_AUTOFILL: "no-autofill",
}

const annSacksConstants = {
  asBrandName: "annsacks",
  asBrandNameWithCase: "AnnSacks",
  asSourceChannel: "asus",
}

const favoritesEndPoint = "/shopping-list/Favorites"

const createFavoritesEndPoint = "/shopping-list/create"

const addFavoritesEndPoint = (id, type) => {
  return `/shopping-list/add/${id}?type=${type}`
}

const removeFavoritesEndPoint = id => {
  return `/shopping-list/remove/items/${id}`
}
const SWATCH_NA = "swatch_NA"
const ADD_10_MINUTES = 600000
export const MINUTE_MILLISECONDS = 60000
const PRIVACY_COOKIE_CLICKED = "is_privacy_cookie_clicked"
const GLOBAL_CONFIGURATION_PATH =
  "/bin/kohler/services/globalconfig.kohler.json"
export const DOMAIN = process.env.NEXT_PUBLIC_GLOBALCONFENV
const GLOBAL_CONFIGURATION_ENDPOINT = DOMAIN + "/api/globalconfig"
const locationIpEndPoint = "/maps/location/ip/"
const locationZipEndPoint = "/maps/location/zipcode/"
const STORE_MIN_DISTANCE = 64
const STORE_MAX_DISTANCE = 1000
export const TIMEOUT_1500 = 1500
const LOCATION_API_TRIGGER_INTERVAL = 1800000 // 30mins
const STORE_DETAILS_API_ENDPOINT = DOMAIN + "/api/storedetails"
const DEFAULT_STORE_DETAILS_API_PATH = "/bin/kohler/services/storedetails?path="
const GET_PROFILE_ENDPOINT = "/customer/me"
const ZIP_FILE_DOWNLOAD_ENDPOINT = "/catalog/zip-file-download"
const SEARCH_PLP_ENDPOINT = "search/plp"
const MY_ACCOUNT_PATH = "/my-account"
// cart Dicount
const stopedByPreviousDiscount = "ApplicationStoppedByPreviousDiscount"
const maxAppReached = "MaxApplicationReached"
const discountMatchesCart = "MatchesCart"
const emailSubscribeEndPoint = "/crm/newsletter/subscription"
const TOAST_MESSAGE_DEFAULT_DURATION = 5000 // 5seconds
const editAddressEndPoint = "customer/address"
export const FIND_MY_ORDERS_V1_ENDPOINT = "/checkout/orders/v1/query"
export const FIND_MY_ORDERS_ENDPOINT = "/checkout/orders/query"
const SPLIT_ORDER = "checkout/ordersplit"
const GET_GUEST_TOKEN_ENDPOINT = DOMAIN + "/api/token"
// Membership
const KEY_SPECIFIER_QUERRY_SELECTOR_URL = 'a[href="#KeySpecifier"]'
const KEY_SPECIFIER_API_URL_ENDPOINT = "/membership/assign/persona"
const MEMBERSHIP_API_URL_ENDPOINT = "/membership/kohler-associate/entry"
const MEMBERSHIP_QUERRY_SELECTOR_URL = 'a[href="#AssociateMembership"]'
const FRIENDS_AND_FAMILY_QUERRY_SELECTOR_URL = 'a[href="#FriendsAndFamily"]'
const FRIENDS_AND_FAMILY_API_URL_ENDPOINT = "/membership/assign/persona"
// Store Appointment
export const STORE_APPOINTMENT_ANCHOR_VALUE = "#StoreAppointment"
// Return Slips
export const RETURN_SLIPS_API_ENDPOINT = "/return/slip"
export const RETURN_SLIPS_PAGE_URL = "returns/return-slips"

const MORE_OPTIONS = {
  LEARN_MORE: "Learn More",
  EXPLORE_MORE: "Explore More",
  FREE_QUOTE: "Get a FREE Quote",
  FIND_PRO: "Find a Pro",
  INSTALLATION_SERVICES: "Buy Now",
}
const DISABLE_SROLL_PATH = [
  "home-energy/home-generators",
  "buying-guides/bath-tub-buying-guide",
  "services/installation-services",
]

const DEFAULT_SCROLL = {
  scroll: 60,
  backToTop: 20,
  freeQuote: 120,
  findAPro: 120,
  installationServices: 120,
}

// order confirmation
const orderConstants = {
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
  CREDIT_CARD: "CREDIT_CARD",
  PAYPAL: "PP",
  ACI_PAYPAL: "Paypal",
  SHIPPED: "Shipped",
}
export const PAYPAL_TYPES = ["PP", "Paypal", "PAYPAL", "PayPal", "paypal"]
export const CARD_TYPES = ["CREDIT_CARD", "credit_card", "CARD", "card"]
export const PCIPAL_TYPES = ["PCIPAL", "PciPal", "pcipal", "PCIPal", "PCI_Pal"]

const GET_ORDER_DETAILS_ENDPOINT = "checkout/orders"
const DEFAULT_CARD_DETAILS_API_PATH =
  "/bin/kohler/services/list?path=/content/kohler"
const MY_SERVICES_ENDPOINT =
  "/shopping-list/MyServices?lang=" + process.env.NEXT_PUBLIC_LOCALE

const MY_FAVORITES_ENDPOINT = "/shopping-list/Favorites"

const COMPONENT_TYPES = {
  AEMFORM: "aemform",
  PRODUCTCARD: "productcard",
  ROOT_CONTAINER: "root",
  CONTAINER: "container",
  VIDEO: "video",
  AUTH_MODAL: "authmodal",
  NEWSLETTER: "newsletter",
  TEASER: "teaser",
  CAROUSEL: "carousel",
  SLICK: "carousel-slick",
  SPACER: "spacer",
  TEXT: "text",
  TAB: "tab",
  BREADCRUMB: "breadcrumb",
  PRODUCTLIST: "productlist",
  SEARCH: "search/v1/search",
  EMBED: "embed",
  BRAND_SWITCHER: "brand-switcher",
  UTILITY_NAV_HEADER: "utilitynavheader",
  UTILITY_WIDGET: "utilitywidget",
  TABS: "tabs",
  IMAGE: "image",
  SITEWIDE_WARNING: "sitewide-warning",
  IMAGEV3: "image/v3/image",
  CAROUSELSLICK: "carousel-slick",
  TOASTER: "toaster/v1/toaster",
  COMPARE_PRODUCTS: "compareproducts",
  MAIN_FOOTER: "mainfooter",
  ADDITIONAL_FOOTER: "additionalfooter",
  NEWSLETTER_SIGNIN: "newslettersignin",
  NEWSLETTER_SIGNUP: "newslettersignup",
  CART_LANDING: "cart-landing",
  CHECKOUT: "checkout",
  ORDER_CONFIRMATION: "orderconfirmation",
  ORDER_STATUS: "orderstatus",
  ORDER_HISTORY: "orderhistory",
  ORDER_DETAILS: "orderdetails",
  SHARED_CART: "sharedcart",
  PAIRS_WELL_WITH: "pairs-well-with",
  HELPSUPPORT: "help-support",
  GLOBAL_NAVIGATION: "globalnavigation",
  PROMOBANNER: "plp-promo-banner",
  ACCOUNT_SETTINGS: "accountsettings",
  MY_SERVICES: "myservices",
  MY_FAVORITES: "myfavorites",
  CHANGE_PASSWORD: "changepassword",
  MY_PRODUCTS: "myproducts",
  PRODUCT_DETAILS: "pdp/v1/pdp",
  PRODUCT_DETAILS_ACCORDION: "accordion",
  PRODUCT_DETAILS_EXFPDP: "exfpdp/v1/exfpdp",
  PRODUCT_DETAILS_REVIEW: "components/review",
  REGISTER_OFFLINE_PRODUCTS: "register-offline-products",
  REGISTER_ONLINE_PRODUCTS: "register-online-products",
  KNOWLEDGE_ARTICLE: "knowledge-article/v1/knowledge-article",
  BROWSE_ALL_STORES: "browseallstores",
  STORE_FILTER: "storefilter",
  LITERATURE: "literature",
  CONTACT_US: "contactus",
  FINDING_MODEL_NUMBER: "finding-model-number",
  TECHNICAL_SPECIFICATION: "technicalspecs",
  PRESS_LANDING: "press-release-landing",
  UPSELL_CONTAINER: "container-up-sell",
  FIND_STORE: "findstore",
  INPAGE_SEARCH: "in-page-search",
  TITLE: "title",
  KEY_SPECIFIER: "key-specifier",
  DYNAMIC_SEARCH: "dynamicsearch",
  ASSOCIATE_MEMBERSHIP: "associate-membership",
  INSPIRE_VIDEO: "inspire-video",
  IMAGE_CLUSTER: "imagecluster",
  SHOP_THE_ROOM_CARD: "shoptheroomcard",
  INSTALL_DESIGN_SERVICES: "v1/installdesignservices",
  PROFESSIONAL_DETAILS: "professional-detail",
  FRIENDS_AND_FAMILY: "friends-family",
  FIND_A_PRO_BY_ZIP: "find-pro-by-zip",
  FIND_A_PRO_RESULTS: "find-a-pro-results",
  LIST: "list",
  STORE_APPOINTMENT: "store-appointment",
  PRODUCTCARD_V3: "productcard-v3",
  SHOP_THE_ROOM_DETAIL: "shoptheroomdetail",
  ROOM_DETAIL: "roomdetail",
  GATED_CONTENT: "gated-content-paths",
  PRODUCT_CARD_V4: "productcard-v4",
  PDP_CURATED_PRODUCTS: "pdp-curated-product",
  PDP_CURATED_RECOMMENDATION: "target-recommendations",
  SHOP_THE_ROOM_PAGE: "shoptheroomlist",
  NAVIGATION_V3: "v3/globalnavigation",
  Lead_Generation: "leadgenform",
  VISUAL_NAV_FILTER: "visual_nav_filter",
  VISUAL_NAV_APPLIEDCLASS: "visual-nav",
  PRODUCT_SLIDER: "productslider",
  RETURN_SLIP: "returnslip",
}

const FRAGMENT_TYPES = {
  HEADER: "header",
  MAIN: "main",
  FOOTER: "footer",
}

const VIDEO_EVENTS = {
  PLAY: "play",
  PAUSE: "pause",
  ENDED: "ended",
  VIDEO_PLAY: "video play",
  VIDEO_PAUSE: "video pause",
  VIDEO_VIEWED: "video viewed",
  VIDEO_COMPLETE: "video complete",
  VIDEO_CLICK: "videoClick",
  PLAY_VIDEO: "videoPlay",
  PAUSE_VIDEO: "videoPause",
  CLOSE_VIDEO: "videoClose",
  CLOSE: "close",
}

export const HERO_BANNER = "hero banner"

const TAB_WIDTH = 768
const DESKTOP_WIDTH = 1280
const ROW_COLUMN_MIN_WIDTH = 1025
const ROW_COLUMN_WIDTH = 1024
const MIN_WIDTH_CLOSEICON = 639
const MAX_WIDTH_MOBILE = 374
const MAX_MID_WIDTH = 1600

// PLP
// sort constants
const KEYCODE = { ENTER: 13, ESC: 27, SPACE: 32, UP: 38, DOWN: 40, TAB: 9 }
// Find a store
export const FINDLOCATIONKEYCODE = { LEFTARROW: 37, RIGHTARROW: 39 }
export const LOCATIONSCONST = {
  LocationType: "KOHLER Store",
  paramSpatialFilter: 161,
  status: 200,
}

export const MILLISECONDSADAY = 86400000

// press room

export const PRESS_ROOM_PATH = "/en/press-room"

// Filter
const queryParamsToPersist = ["sort", "keyword", "tab"]

const DEFAULT_NEWELETTER_POPUP_TRIGGER_TIME = 9

export const PLP_END_POINT = "/apirequest/search/v1/plp"
export const PLP_END_POINT_CLIENT = "/search/v1/plp"
const PLP_END_POINT_SUBSCRIPTION_KEY = "/lw/plp"
const PDP_END_POINT_SUBSCRIPTION_KEY = "/lw/v1/pdp/product"
export const BUNDLE_PDP_END_POINT_SUBSCRIPTION_KEY = "/lw/pdp/"

const apimSubscriptionKey = process.env.APIM_SUBSCRIPTION_KEY
const HELP_FAQ_END_POINT = "/search/plp"
const DEFAULT_PRODUCT_COUNT_PLP = 30
const DEFAULT_TECHNICAL_SPECT_COUNT = 30
const TECHNICAL_SPECT_SEARCH_COUNT = 5

const PROFILE_END_POINT_CLIENT = "/search/v1/profile"

const debounceThresholdCheckUserExists = 500

const customActivityEvents = ["click", "keydown"]

const PAGE_TYPES = {
  CATEGORY_LANDING_PAGE: "category landing page",
  SHARE_CART_LANDING_PAGE: "share cart landing page",
  LOCATION_LANDING_PAGE: "landing:location info",
}
const PRODUCTS_PER_PAGE = [30, 60, 90]
const imgPlaceholderData =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
// Account Settings constants
const EDIT_PROFILE_ENDPOINT = "/customer/profile"
const DELETE_ACCOUNT_ENDPOINT = "/customer/account"
const CHANGE_ACCOUNT_PASSWORD_ENDPOINT = "/customer/change_password"
export const EMPTY_PIXEL =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
export const FULL_FAVORITE_BASE64 =
  "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjNweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjMgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+RmF2b3JpdGVzIEJsYWNrIGZpbGxlZCBJY29uPC90aXRsZT4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJGYXZvcml0ZXMtQmxhY2stZmlsbGVkLUljb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNDk5OTcyLCAwLjUwMDAwMCkiIGZpbGw9IiM0OTQ5NDkiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xLjY5NDYxMTg5LDEuNjk1NTU5NDQgQy0wLjUwMTg5NzgzLDMuODk3MDQ5NDMgLTAuNTcwMjc5NjkxLDcuNDU1ODUwMTEgMS41MzEyODgxMyw5LjcwOTk2MzkgTDEuNjg4MjMwMDEsOS44NzMxOTUyIEwxMS4wMDE3MDE4LDE5LjIwNzkwMTYgTDIwLjI4Mzc4NTQsOS45MDUxNTEyIEwyMC40NDExNTc3LDkuNzQyNTQ2OCBDMjIuNTY5NTIwNiw3LjQ2MDMwODEzIDIyLjUwOTU1NjcsMy45MDEzNjA3OSAyMC4zMDg3NDU0LDEuNjk1NTU5NDQgTDIwLjEyMjgzOTUsMS41MTcyMDk4NyBDMTcuODU2NDMxMywtMC41NjM1MzUwOTUgMTQuMzM0NTc5MiwtMC41MDQwODUyMzkgMTIuMTM5OTEwNiwxLjY5NTU1OTQ0IEwxMS4wMDEwMjgsMi44MzYgTDkuODYzNDQ2NjMsMS42OTU1NTk0NCBDNy42Njg3NzgwNCwtMC41MDQwODUyMzkgNC4xNDY5MjYwMiwtMC41NjM1MzUwOTUgMS44ODA1MTc3NywxLjUxNzIwOTg3IEwxLjY5NDYxMTg5LDEuNjk1NTU5NDQgWiIgaWQ9IkZhdm9yaXRlcy1JY29uIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

export const EMPTY_FAVORITE_BASE64 =
  "data:image/svg+xml;base64,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"

const TABS_NOT_REQUIRED_GRIDICON = [
  "inspiration",
  "technical",
  "resources",
  "help",
]
// myProducts endPoints
const MY_PRODUCT_SEARCH_CATALOG = "/search/full-catalog"
const MY_PRODUCT_PRODUCT_REGISTRATION = "/crm/product/registration"
const PDP_TEASER_DETAILS = DOMAIN + "/api/pdpTeaserDetails"
const PLUMBING_SERVICE_PARTS = "PlumbingServiceParts"
const PARTS = "parts"

// contact us endpoints
const CONTACT_US_VALIDATE_RECAPTCHA_ENDPOINT = "/crm/webtocase"

export const API_SUCCESS_STATUS = "succeeded"
export const API_FAILURE_STATUS = "failed"
export const PDP_DEFAULT_IMAGE = process.env.PDP_DEFAULT_IMAGE

export const EMBED_TYPE_SCRIPT = "SCRIPT"
export const EMBED_TYPE_HTML = "HTML"
export const VISUALICON_ARIA_LABEL = "View at 360 degree mode"
export const MATTERPORT_ARIA_LABEL = "virtual tour popup"

// tab component constants
export const NS = "cmp"
export const IS = "tabs"
export const keyCodes = {
  END: 35,
  HOME: 36,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
}
export const selectors = {
  self: "[data-" + NS + '-is="' + IS + '"]',
  active: {
    tab: "cmp-tabs__tab--active",
    tabpanel: "cmp-tabs__tabpanel--active",
  },
}

// privacy-policy constants
export const PRIVACY_ASPATH = "privacy-policy"

// press room constants
export const DOWNLOAD_SPINNER = "download-spinner"

export const postOrderNoOfDays = 45

export const TotalSecsForaDay = 86400000
// teasercaption-repositioning constants
export const TEASER_CAPTION_CLASSES =
  ".teaser.img-right-caption-left, .history-module-vertical-image.image-right, .history-module-with-SQR-img.image-left, .img-caption-style-left.img-right-with-number__intend, .img-caption-style-left.img-right-with-number"

// Add conditional wrapper in AEMGRID component for the provided grouped elements.
export const groupedComponents = [
  COMPONENT_TYPES?.BREADCRUMB,
  COMPONENT_TYPES?.CAROUSEL,
]
export const SUCCESS = "success"

// Product support center constants
export const SUPPORT_CENTER_PATH = "/en/support/product-support-center"

// my lists constant
export const MY_LISTS_PATH = "/en/my-account/my-lists"

// help-and-faq constants
export const HELP_AND_FAQ = "help-and-faq"

export const resourceFacetLabels = [
  "ResourceVntanaProductId_s",
  "ResourceVntanaProductIdList_ss",
  "ResourceNvznIdList_ss",
  "ProductIsExclusive_s",
  "RegionSoldOnline_s",
  "CustomerFacingBrand_s",
  "ProductBusinessUnit_ss",
  "BundlePLPImageURL_s",
  "ctProductType_s",
]

export const DEVICE_TYPE_DESKTOP = "desktop"

// find a pro constants
export const FIND_A_PRO_PATH = "/en/services/find-a-pro"
export const FIND_A_PRO_HASH = "#findapro"

// shop the room details page
export const SHOP_THE_ROOM = "shop-the-room"

// Installation services constants
export const INSTALLATION_SERVICES_HASH = "#InstallService"
export const INSTALLATION_SERVICES_PATH = "/en/services/installation-services"
export const INSTALLATION_SERVICES_ASPATH = "installation-services"
export const BUYING_GUIDE_ASPATH = "buying-guides"

// cart and checkout constants
export const CART_URL = "/en/cart"
export const CHECKOUT_URL = "/en/checkout"

export const COUNTRY = {
  US: "US",
}

// Technical Specifications constants
export const TECHNICAL_SPECIFICATION_PATH =
  "/en/for-professionals/technical-specifications"

// Browse all stores constants
export const BROWSE_ALL_STORES = "browse-all-stores"
export const BROWSE_ALL_STORES_URL = "/locations/browse-all-stores"

export const MY_LISTS_PATH_FR = "/fr/my-account/my-lists"

// Locations constants
export const LOCATIONS_PATH = "/en/locations"
export const LOCATIONS_ASPATH = "/locations"

// bazaar voice constants
export const BAZAAR_VOICE = "bazaarvoice"

// Redirect constants
export const VANITY_REDIRECT_TYPE = "Vanity"

// teasercaption-repositioning constants
export const TEASER_CAPTION_CLASSES_LIST = [
  "img-right-caption-left",
  "img-right-caption-left mobile-cta-double",
  "mobile-cta-double img-right-caption-left",
  "img-right-caption-left mobile-cta-single",
  "history-module-vertical-image image-right",
  "history-module-with-SQR-img image-left",
  "img-caption-style-left img-right-with-number__intend",
  "img-caption-style-left img-right-with-number",
]

export const GATED_HASHES = ["#login", "#signup", "#createaccount", "#signin"]
export const FRAUD_CHLLENGE_STATUS = ["CHALLENGE", "ERROR", "DENY"]
export const IN_REVIEW_ORDER_STATUS = [
  "PA_PENDING",
  "ERROR_STATE",
  "FRAUD_HOLD",
  "FRAUD_CANCELLED",
]
export const ORDER_IN_RECEIVED_STATUS = ["RECEIVED", "CREATED"]

export const myListContainerBreakPoints = {
  default: 3,
  1920: 3,
  1440: 3,
  1024: 2,
  812: 2,
  375: 1,
}

export const MONTH_NAMES_EN = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]

export const MONTH_NAMES_FR = [
  "Janvier",
  "Février",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Août",
  "Septembre",
  "Octobre",
  "Novembre",
  "Décembre",
]

export const NODE_NAMES = {
  BUTTON: "BUTTON",
  IMG: "IMG",
}

export const ONETRUST_IDENTIFIER = "cookielaw"

export const BV_SCRIPT_URL = process.env.NEXT_PUBLIC_BV_SCRIPT
export const LW_APP_NAME = process.env.NEXT_PUBLIC_LW_APP_NAME

export const SEARCH_TABS = {
  PRODUCTS: "Products",
  PARTS: "Parts",
  INSPIRATION: "Inspiration",
  TECHNICAL: "Technical",
  RESOURCES: "Resources",
  HELP: "Help",
}
export const INITIAL_SEARCH_TABS_COUNT = {
  [SEARCH_TABS.PRODUCTS]: 0,
  [SEARCH_TABS.PARTS]: 0,
  [SEARCH_TABS.INSPIRATION]: 0,
  [SEARCH_TABS.TECHNICAL]: 0,
  [SEARCH_TABS.RESOURCES]: 0,
  [SEARCH_TABS.HELP]: 0,
}
export const searchFeatureResults = "/bin/kohler/searchpanelfragment"
export const GET_CITY_AND_STATE_BY_ZIPCODE = "/maps/v2/location/zipcode"

export {
  ROW_COLUMN_MIN_WIDTH,
  TAB_WIDTH,
  DESKTOP_WIDTH,
  authorBaseUrl,
  publisherBaseUrl,
  dataUrl,
  headerUrl,
  footerUrl,
  staticClasses,
  pageUrl,
  apiBaseUrl,
  oktaTokenEndpoint,
  getCartEndPoint,
  createCartEndPoint,
  getStockEndPoint,
  cartItemsEndPoint,
  sharedCartItemsEndPoint,
  mergeCartEndPoint,
  SWATCH_NA,
  ADD_10_MINUTES,
  PRIVACY_COOKIE_CLICKED,
  GLOBAL_CONFIGURATION_PATH,
  GLOBAL_CONFIGURATION_ENDPOINT,
  locationIpEndPoint,
  locationZipEndPoint,
  STORE_MIN_DISTANCE,
  STORE_MAX_DISTANCE,
  LOCATION_API_TRIGGER_INTERVAL,
  STORE_DETAILS_API_ENDPOINT,
  DEFAULT_STORE_DETAILS_API_PATH,
  discountEndPoint,
  stopedByPreviousDiscount,
  maxAppReached,
  discountMatchesCart,
  taxEndPoint,
  shareCartEndPoint,
  signupEndPoint,
  emailSubscribeEndPoint,
  deleteCartEndPoint,
  GET_PROFILE_ENDPOINT,
  addAddressEndPoint,
  addressSuggestionEndPoint,
  TOAST_MESSAGE_DEFAULT_DURATION,
  validateTokenEndPoint,
  editAddressEndPoint,
  searchPlpEndPoint,
  inPageSearchEndPoint,
  searchProfilePlpEndPoint,
  orderSubmitEndPoint,
  cartDataUrl,
  checkoutDataUrl,
  orderConfirmationDataUrl,
  paymentEndPoint,
  payPalPaymentEndPoint,
  SPLIT_ORDER,
  orderConstants,
  GET_ORDER_DETAILS_ENDPOINT,
  DEFAULT_CARD_DETAILS_API_PATH,
  sharedCartUrl,
  orderDetailsPageDataUrl,
  orderHistoryPageDataUrl,
  returnSlipPageDataUrl,
  orderStatusPageDataUrl,
  baseUrl,
  cartPage,
  favoritesEndPoint,
  COMPONENT_TYPES,
  FRAGMENT_TYPES,
  VIDEO_EVENTS,
  ZIP_FILE_DOWNLOAD_ENDPOINT,
  SEARCH_PLP_ENDPOINT,
  addFavoritesEndPoint,
  createFavoritesEndPoint,
  removeFavoritesEndPoint,
  KEYCODE,
  DEFAULT_NEWELETTER_POPUP_TRIGGER_TIME,
  GET_GUEST_TOKEN_ENDPOINT,
  apimSubscriptionKey,
  PLP_END_POINT_SUBSCRIPTION_KEY,
  PDP_END_POINT_SUBSCRIPTION_KEY,
  DEFAULT_PRODUCT_COUNT_PLP,
  queryParamsToPersist,
  debounceThresholdCheckUserExists,
  customActivityEvents,
  PROFILE_END_POINT_CLIENT,
  PAGE_TYPES,
  PRODUCTS_PER_PAGE,
  accountSettingsPageDataUrl,
  MyServicePageDataUrl,
  MyProductsPageDataUrl,
  MY_SERVICES_ENDPOINT,
  MyFavoritesPageDataUrl,
  MyListsPageDataUrl,
  MY_FAVORITES_ENDPOINT,
  PRODUCT_DATA_URL,
  loveYourLookDataUrl,
  pageNotFoundDataUrl,
  REGISTER_OFFLINE_PRODUCTS_DATA_URL,
  searchDataUrl,
  imgPlaceholderData,
  EDIT_PROFILE_ENDPOINT,
  DELETE_ACCOUNT_ENDPOINT,
  CHANGE_ACCOUNT_PASSWORD_ENDPOINT,
  TABS_NOT_REQUIRED_GRIDICON,
  MY_PRODUCT_SEARCH_CATALOG,
  MY_PRODUCT_PRODUCT_REGISTRATION,
  REGISTER_ONLINE_PRODUCTS_DATA_URL,
  PDP_TEASER_DETAILS,
  authorPreviewBaseUrl,
  authorPreviewUserName,
  authorPreviewPassword,
  previewContentPrefix,
  FETCH_PRODUCT_REG_ENDPOINT,
  MY_PRODUCTS_ENDPOINT,
  PLUMBING_SERVICE_PARTS,
  PARTS,
  FAQ_PAGE_DATA_URL,
  browseAllStoresURL,
  HELP_FAQ_END_POINT,
  DEFAULT_TECHNICAL_SPECT_COUNT,
  LITERATURE_DATA_URL,
  CONTACT_US_VALIDATE_RECAPTCHA_ENDPOINT,
  MY_ACCOUNT_PATH,
  TECHNICAL_SPECIFICATION_DATA_URL,
  TECHNICAL_SPECT_SEARCH_COUNT,
  PRESS_LANDING_URL,
  FIND_STORE_URL,
  KEY_SPECIFIER_QUERRY_SELECTOR_URL,
  KEY_SPECIFIER_API_URL_ENDPOINT,
  MEMBERSHIP_API_URL_ENDPOINT,
  MEMBERSHIP_QUERRY_SELECTOR_URL,
  ARTICLE_CONTENT_END_POINT,
  ARTICLE_IMG_END_POINT,
  FAVORITES_LIST_END_POINT,
  FAVORITES_LIST_LIMIT,
  MORE_OPTIONS,
  DEFAULT_SCROLL,
  publicWebsiteUrl,
  DISABLE_SROLL_PATH,
  FRIENDS_AND_FAMILY_QUERRY_SELECTOR_URL,
  FRIENDS_AND_FAMILY_API_URL_ENDPOINT,
  annSacksConstants,
  USER_LIST_DELETE_END_POINT,
  USER_LIST_PRODUCT_DELETE_POINT,
  MIN_WIDTH_CLOSEICON,
  MAX_WIDTH_MOBILE,
  ROW_COLUMN_WIDTH,
  MAX_MID_WIDTH,
}
export const SEAT_TYPES = ["Toilet Seats", "Bidet Seats"]
export const EXCLUDE_PAGES = ["/checkout"]
export const UTILITY_CONSTANTS = {
  FAVOURITES: "favourite",
  SHARE: "share",
  PRINT: "print",
  DOWNLOAD: "download",
}
export const TEASER_CLASSES = ["hero-banner-full-bleed-image", "hero-video-3-4"]
export const SHOP_THE_ROOM_CLASSES = ["shop-the-room"]
export const MIN_DELAY = 100
export default CONSTANTS
export const ADDRESS_SUGGESTION_DEFAULT_COUNTRY = "USA"
export const AFFIRM_SHOP_URL = "https://www.affirm.com/shop/kohler-web"

export const FREIGHT_SHIPPING_TYPES = ["Freight", "Freight Shipping"]

export const SEARCH_PDP_FL = [
  "id",
  "ctId_s",
  "ProductWaterSense_ss",
  "masterSKU_s",
  "CustomerFacingSKU_s",
  "ProductProductRecommendedAccessories_ss",
  "Product_Category",
  "ProductLocalCategory_s",
  "ProductServices_ss",
  "ProductPriceSpiderIncluded_s",
  "SKUIsProjectPack_s",
  "ProductBrandNameDisplay_s",
  "Collapse_Field_s",
  "Color.SKU.Details_ss",
  "productName_s",
  "RegionBrandName_s",
  "variantList.sku_ss",
  "ProductRequiredAccessoryGroup_ss",
  "ProductYoutubeID_s",
  "productImages.labelWithUrl_ss",
  "ProductDescriptionProductShort_s",
  "productRegionAllVariantDiscontinued_b",
  "ProductBrandName_s",
  "RegionOnBackOrder_s",
  "ProductOverallLengthInches_s",
  "ProductOverallWidthInches_s",
  "ProductOverallHeightInches_s",
  "ProductWebFeatures_ss",
  "ProductFreightPolicyType_s",
  "category1_s",
  "RegionReleaseforShipment_dt",
  "priceList.*.finalPrice_d",
  "priceList.*.saleOffer_s",
  "priceStartingAt.*_d",
  "priceList.*.discountedPrice_d",
  "priceList.*.price_d",
  "ProductBadgeInfo_ss",
  "ProductWebTechnology_ss",
  "ProductNarrativeDescription_s",
  "ProductWebMaterial_ss",
  "ProductWebInstallation_ss",
  "ProductCaliforniaProp65WarningDisclaimer_s",
  "ProductWebHydrotherapy_ss",
  "ProductWebRebates_ss",
  "ProductResource.DXFPlanView.resourceFullWebURL_ss",
  "ProductResource.DWGPlanView.resourceFullWebURL_ss",
  "ProductResource.DXFFrontView.resourceFullWebURL_ss",
  "ProductResource.DWGFrontView.resourceFullWebURL_ss",
  "ProductResource.DXFSideView.resourceFullWebURL_ss",
  "ProductResource.DWGSideView.resourceFullWebURL_ss",
  "ProductResource.3DDXFSymbol.resourceFullWebURL_ss",
  "ProductResource.3DDWGSymbol.resourceFullWebURL_ss",
  "ProductResource.3DRevit.resourceFullWebURL_ss",
  "ProductResource.3D3DS.resourceFullWebURL_ss",
  "ProductResource.3DSketchup.resourceFullWebURL_ss",
  "ProductResource.3DOBJ.resourceFullWebURL_ss",
  "ProductResource.CutOutDXF.resourceFullWebURL_ss",
  "ProductResource.SpecPDFFileName.resourceFullWebURL_ss",
  "ProductResource.SpecPDFFileName.resourceTitle_ss",
  "ProductResource.EnvironProdDecl.resourceFullWebURL_ss",
  "ProductResource.EnvironProdDecl.resourceTitle_ss",
  "ProductResource.HomeownersGuide.resourceFullWebURL_ss",
  "ProductResource.HomeownersGuide.resourceTitle_ss",
  "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss",
  "ProductResource.PartsPDFFileName.resourceFullWebURL_ss",
  "ProductResource.InstallationWithoutSPPDF.resourceTitle_ss",
  "SKUDiscontinuedDate_dt",
  "ProductResource.YouTubeInstallVideo.resourceName_ss",
  "ProductResource.YouTubeInstallVideo.resourceTitle_ss",
  "ProductResource.InteractiveSVG.resourceName_ss",
  "ProductResource.InteractiveSVG.resourceTitle_ss",
  "ProductProductNo_s",
  "ctProductType_s",
  "CustomerFacingBrand_s",
  "isCollapsedPDP_b",
  resourceFacetLabels.join(","),
  "CrossSellRecommendationSKUList_ss",
  "primaryBundleSKU_s",
  "bundleSKUList_ss",
  "title_s",
  "features_s",
  "ItemResource.IMGSpinSet.resourceFullWebURL_ss",
  "ItemResource.IMGSpinSet.resourceName_ss",
  "ItemResource.IMGSpinSet.resourceAltText_ss",
  "ItemResource.IMGSpinSet.resourceType_ss",
  "productLocalCategoryBreadCrumb_s",
]

export const FEATURE_FLAGS_CHECKOUT_PAYLOAD = [
  "MYSQLCONNSTR_ACI_PAYMENT_FLAG",
  "MYSQLCONNSTR_ACI_GLOBAL_PAYMENT_FLAG",
  "MYSQLCONNSTR_DISABLE_ADD_CART",
  "MYSQLCONNSTR_EXCLUDE_PO_BOX_ADDRESSES",
  "MYSQLCONNSTR_DISABLE_BILLING_CUSTOM_DROPDOWN",
  "MYSQLCONNSTR_ENABLE_PARTS_VIEWER_V2",
  "MYSQLCONNSTR_ENABLE_ORDER_DETAILS_TABS",
  "MYSQLCONNSTR_ENABLE_NARVAR_RETURN",
  "MYSQLCONNSTR_ENABLE_PAYPAL_EXPRESS_CHECKOUT",
  "MYSQLCONNSTR_ENABLE_SHOPPING_LISTS_V2",
  "MYSQLCONNSTR_ENABLE_SAVE_TO_LIST_FOR_QUICK_VIEW",
  "MYSQLCONNSTR_ENABLE_VISUAL_SEARCH_V1",
  "MYSQLCONNSTR_ENABLE_CONFIGURATOR",
  "MYSQLCONNSTR_ENABLE_CHECKOUT_V2",
  "MYSQLCONNSTR_ENABLE_ALBY_FOR_PERSONAS",
  "MYSQLCONNSTR_ENABLE_ACI_CREDIT_CARD_V2",
  "MYSQLCONNSTR_ENABLE_GLOBAL_VISUAL_SEARCH_V1",
  "MYSQLCONNSTR_ENABLE_EXECUTING_ORDER_LOGGING_API",
]
export const CONTACT_US_PAGE_URL_US = "/en/support/contact"
export const CONTACT_US_PAGE_URL = "/support/contact"

export const CORE_GLOBAL_CONFIG_URL = "/api/globalconfig"
export const NUMERIC_REGX = /^[0-9]+$/

export const GENERIC_ERROR_MESSAGE = "Something went wrong. Please try again..."

export const EXCEPTIONAL_SITENAME = "kohler"

export const STORE_APP_LD_JSON = {
  context: "https://schema.org",
  type: "Store",
  addressType: "PostalAddress",
  geoType: "GeoCoordinates",
  openingHourType: "OpeningHoursSpecification",
  openingDays: {
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
  },
}

export const BREAD_CRUMB_APP_LD_JSON = {
  context: "https://schema.org",
  breadcrumbList: "breadcrumbList",
  listItemType: "ListItem",
}

export const PDP_SLIDER_SIZES = {
  largeIpadSize: 1024,
  mobileSize: 767,
  desktopSliderImages: 15,
  smallesIpadSliderImages: 12,
  imageReelTitle: "image reel",
  portateDevice: 812,
  visualNavPlp: 1023,
}
export const ORDER_THANKYOU = "order:thank you"
export const ORDER_CONFIRMATION = "order confirmation"
export const VALID_GLOBA_CONFIG_PATHS =
  /^(?!.*[\{\}#%])(?!(.*https?:\/\/|.*www\.|.*\.com))[a-zA-Z0-9\/:._=?-]+$/

export const PriceRangeFrench = "Fourchette de prix"
export const ML_API_MODEL_1 = "/pia-qa/model1"
export const ML_API_MODEL_2 = "/pia-qa/model2"

export const LOCALE_ENGLISH = "en-US"
export const LOCALE_CANADA_FR = "fr-CA"

export const PRICE_RANGE = "Price_Range"
export const PDP_FIND_ON_DISPLAY = "pdp:find on display"
export const PRICE_RANGE_FRENCH_LOCALE = "priceList.ANY.finalPrice_d"
export const DISCOUNTED_PRICE_FACET_LABEL = "discountedPriceStartingAt"

export const PDP_TYPE = "regular w/ required items"

export const PDP_FEEDBACK = "pdp:provide feedback"

export const SHOP_TOILET_SEATS = "shop toilet seats"
export const ORDER_STATUS_PAGE = "order status"
export const LITERATURE = "literature"
export const TECHNICAL_SPECIFICATIONS = "technical specs"
export const HOW_TO_BECOME_A_KPN = "how to become a kohler partner"
export const TWO_WAYS_TO_BE_A_KPN = "two ways to be a kohler partner"
export const JOIN_NOW = "Join Now"
export const SEARCH_INTERNAL_TYPE = {
  sterlingResults: "view sterling results",
  compare: "compare",
  partsDiagram: "parts diagram",
  serviceParts: "service parts",
}
export const INSTALL_ITEMS = "items required for install test"
export const INSTALL_ITEMS_EDIT = "edit items required for install"
export const MY_ACCOUNT_MODAL = "my account modal section"
export const CREATE_ACCOUNT = "create account"
export const BRAND_NAME = {
  annSacks: "Ann Sacks",
  sterling: "STERLING",
  homeEnergy: "Home Energy",
}
export const BROWSE_ALL_KOHLER_STORES = "browse all kohler stores"
export const FIND_A_STORE = "find a store"
export const PDP_DETAILS = "pdp:product details"
export const PDP_FAVORITE = "favorites"
export const PDP_GUEST_FAVORITE = "guest favorites"
export const NAVIGATION_TYPE = {
  PRODUCT: "product navigation",
  MEGA_MENU: "mega menu navigation",
  GLOBAL: "global navigation",
}
export const CHECKOUT_PAYMENT = "payment & billing"

export const HEADER_NAV_TABS_WRAPPER_ID = "header-nav-tabs-wrapper"
export const PDP_TYPES = "regular finished goods"
export const STOCKS = {
  OUT_OF_STOCK: "out of stock",
  IN_STOCK: "in stock",
}
export const PERCENT_OFF = "percentOff|"
export const REGULAR_PRICE = "regular price"
export const TARGETED_DOMAIN_TO_MONITOR = "kohlermetrics"
export const tooltip = "/icons/tooltip-red.svg"
export const INSPIRATION_PAGE_NAME = {
  KIPS_BAY_DECORATOR: "kips bay decorator showhouse gallery dallas",
  PROJECT_GALLERY: "project gallery",
}
export const CONTACT_US_SUPPORT = "support:contact:form"
export const CONTACT_US_FORM = "support:contact"
export const HELP_AND_SUPPORT = "help and support"
export const HELP_SUPPORT = "help support"
export const CALL_OUR_TEAM = "call our team"
export const SSR_PLP_FL = [
  "id",
  "masterSKU_s",
  "sku_s",
  "RegionSoldOnline_s",
  "ctProductType_s",
  "productRegionAllVariantDiscontinued_b",
  "CustomerFacingBrand_s",
  "ProductBusinessUnit_ss",
  "masterCustomerFacingSKU_s",
  "SKUColorSwatchFilename_ss",
  "SKUColorSwatchFilename_s",
  "ProductDescriptionProductShort_s",
  "ProductBrandName_s",
  "metaTitle_s",
  "productName_s",
  "RegionBrandName_s",
  "productImages.url_s",
  "productImages.url_ss",
  "slug_s",
  "Product_Category",
  "displayPriceStartingAt_s",
  "Tile_Title",
  "Collapse_Title_s",
  "Collapse_Description_s",
  "price*",
  "discountedPrice*",
  "variantList.sku_ss",
  "variantList.sku_s",
  "SKUColorFinishName_s",
  "SKUColorFinishName_ss",
  "SKU.Details_ss",
  "Color.SKU.Details_ss",
  "ProductExclusive_s",
  "RegionReleaseforShipment_dt",
  "productImages.labelWithUrl_ss",
  "productImages.labelWithUrl_s",
  "productImageVariantImages.labelWithUrl_ss",
  "RegionOnBackOrder_s",
  "ProductIsRetail",
  "comboSKUAvailable_b",
  "category1_s",
  "ProductBrandNameDisplay_s",
  "ctId_s",
  "ProductResource.InteractiveSVG.resourceName_ss",
  "ProductProductNo_s",
  "ProductResource.InteractiveSVG.resourceTitle_ss",
  "ResourceNvznId_s",
  "ResourceVntanaProductId_s",
  "ResourceVntanaProductIdList_ss",
  "ResourceNvznIdList_ss",
  "ProductIsExclusive_s",
  "Collapse_Field_s",
  "primaryBundleSKU_s",
  "disc_max_price",
  "max_price",
  "RegionIsBackOrderable_b",
  "ProductIsRetail_s",
  "ProductWebFeatures_ss",
  "RegionSoldOnline_s",
  "ProductBusinessUnit_ss",
  "CustomerFacingBrand_s",
  "*.Details_ss",
  "disc_max_price",
  "disc_min_price",
  "BundlePLPImageURL_s",
  "Bundle_s",
  "displayPriceStartingAt_s",
]

export const REMEDY_MODEL_JSON = "/remedy.model.json"

export const SMART_TOILETS_MODEL_JSON = "/smart-toilets.model.json"

export const PRESS_KIT_PAGE_TYPE = "press-kit"
export const BUYING_GUIDE = "Buying Guide"

export const SHOP_THE_LOOK = "shop the look"
export const INTERACTIVE_TAGS = ["A", "BUTTON", "INPUT", "TEXTAREA", "SELECT"]
export const SERVICES = ["Install Services", "Design Services"]

export const VALID_SPACER_SIZES = new Set(["none", "xs", "s", "m", "l", "xl"])

export const SPACER_ALIAS = {
  "top size": "none",
  "bottom size": "none",
  small: "s",
  medium: "m",
  large: "l",
}

export const BUNDLE_LABEL = "BUNDLE"
